import { useTranslation } from 'react-i18next'

import { getRequiredBookingConfirmationValue } from 'entities/kyrgyzstan/lib'

import { AllIcons } from 'shared/ui/app-icon/types'
import { InfoItem } from 'shared/ui/info-item'
import { Paper } from 'shared/ui/paper'
import { Switch } from 'shared/ui/switch'

import type { EditObjectListItem } from '../../model/edit-object-menu-items'

interface EditObjectMenuProps {
  items: EditObjectListItem[]
  bookingConfirmed: boolean
  disabled: boolean
  onItemClick: (item: EditObjectListItem) => void
  onDeleteClick: () => void
}

export const EditObjectMenu = ({
  items,
  bookingConfirmed,
  disabled,
  onItemClick,
  onDeleteClick,
}: EditObjectMenuProps) => {
  const { t } = useTranslation()
  const requiredBookingConfirmed =
    getRequiredBookingConfirmationValue(bookingConfirmed)
  const bookingConfirmationStatusKey = requiredBookingConfirmed
    ? 'kyrgyzstan_block.edit_object.booking_confirmation.active'
    : 'kyrgyzstan_block.edit_object.booking_confirmation.inactive'

  return (
    <Paper
      padding={[0, 16]}
      radius="16px"
    >
      {items.map((item) => (
        <InfoItem
          key={item.id}
          title={item.title}
          subtitle={item.subtitle}
          icon={item.icon}
          onClick={() => onItemClick(item)}
        />
      ))}

      <InfoItem
        key="confirmation"
        title={t('kyrgyzstan_block.edit_object.booking_confirmation.title')}
        subtitle={t(bookingConfirmationStatusKey)}
        icon={AllIcons.SHIELD}
        actionRight={
          <Switch
            isChecked={requiredBookingConfirmed}
            disabled={disabled || requiredBookingConfirmed}
          />
        }
      />

      <InfoItem
        key="delete"
        title={t('kyrgyzstan_block.edit_object.delete.title')}
        icon={AllIcons.REMOVE}
        variant="danger"
        onClick={onDeleteClick}
      />
    </Paper>
  )
}
